export default "__VITE_ASSET__BWfoRtSg__"